import { useLingui } from "@lingui/react/macro";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { useAppForm } from "~/components/ui/form";
import { parseValidationErrors } from "~/lib/errors";
import { useTRPC } from "~/trpc/client";
import { type AuthForgotPasswordInput, authForgotPasswordSchema } from "./forgot-password.schema";

export function useAuthForgotPasswordForm({
	defaultValues,
}: {
	defaultValues?: Partial<AuthForgotPasswordInput>;
} = {}) {
	const { t } = useLingui();
	const trpc = useTRPC();
	const navigate = useNavigate();

	const authForgotPasswordMutation = useMutation(
		trpc.auth.forgotPassword.mutationOptions({
			async onSuccess() {
				await navigate({ to: "/auth/forgot-password/confirmation" });
			},
		}),
	);

	return useAppForm({
		defaultValues: {
			email: "",
			...defaultValues,
		},
		validators: {
			onSubmit: authForgotPasswordSchema,
			onSubmitAsync: async ({ value }) => {
				try {
					await authForgotPasswordMutation.mutateAsync(value);
				} catch (e) {
					return parseValidationErrors(e, t`Something went wrong.`);
				}
			},
		},
	});
}
